import controller from './pqrs-detail.controller';
import template from './pqrs-detail.view.html';

let PqrsDetailComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default PqrsDetailComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pqrs/pqrs-detail/pqrs-detail.component.js
 **/